<template>
  <div>
    <navigation></navigation>
    <div class="about text-left mx-auto" style="max-width: 900px">
      <h3 class="text-center">Text & Press</h3>

      <h3>Text</h3>
      <a href="http://artclubcaucasus.blogspot.com/2009/03/oliver-borner-das-dresden-manifest.html" target="new"><i class="fa fa-external-link"></i> <strong>Das Dresden Manifest, 2009</strong></a><br>written by Holger John and presented at the exhibition „ULTIMATUM – was andere anfingen bringt er zu Ende“<br /><br />

      <h3>Publications</h3>

 
      <div class="card-columns">
         <div class="card border-1 mb-5">
          <img
          v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/publications/bornutti_lookbook.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Bornutti Lookbook 2014</strong><br />
              Published as an edition of 10.
        <br /><br />
        <i class="fa fa-times"></i> sold out<br
              />  </p>
          </div>
        </div>
        <div class="card border-1 mb-5">
          <img
           v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/publications/borner_lukass.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>BORNER LUKAS – 2014</strong><br />
              Catalog featuring the exhibition BORNER LUKAS – MALEREI at the Gallery
        Holger John in Dresden, published as an edition of 500.
        <br /><br />
        <a href="http://galerie-holgerjohn.com/borner-lukass/" target="new"><i class="fa fa-external-link"></i> available at Galerie Holger John</a>
            </p>
          </div>
        </div>
        <div class="card border-1 mb-5">
          <img
           v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/publications/ks_zine.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Kessler Schwarz Lookbook – 2012</strong><br />
              Showcase of the artist group Kessler Schwarz - 
              Limited edition of 30<br /><br />
              
              <i class="fa fa-times"></i> sold out<br
              />
            </p>
          </div>
        </div>
       <div class="card border-1 mb-5">
          <img
           v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/publications/fullclip.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>FULL CLIP – 2011</strong><br />
              A photobook with digital and analog photography. Illustrated, written and shot by Oliver Borner<br /><br />
              <a href="https://issuu.com/borner/docs/fullclip" target="new"
                ><i class="fa fa-external-link"></i>
                watch online<br
              /></a>
             
            </p>
          </div>
        </div>
     
      <!-- end row 1 -->
       
       
        <div class="card border-1 mb-5">
          <img
           v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/publications/woodcuts.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Woodcuts - Oliver Borner</strong><br />
              A catalog featuring the woodcuts I made in 2005 - 2006 - 
              Limited edition of 20<br /><br />
               <a href="https://issuu.com/borner/docs/holzschnitte2006" target="new"
                ><i class="fa fa-external-link"></i>
                watch online<br
              /></a>
            </p>
          </div>
        </div>
      
      </div>
      <!-- end row 2 -->


      <h3>Press appearance</h3>
      <p>
      <a href=" https://vasistas-magazine.com/portfolio/oliver-borner/" target="new"><i class="fa fa-external-link"></i> Vasistas Magazine feature 2016</strong>
      </a></p>
   

      <ul>
        <li>Top Magazin – Spring 2011</li>
        <li>Vice Magazine – Volume 6 Number 1</li>
        <li>Freie Presse 21.07.10 – Sexy und Gefühlsecht</li>
        <li>DNN 04.11.09 – DNN Kunstauktion</li>
        <li>SZ 04.05.08 – Kaufhaus Wabe with Holger John</li>
        <li>DNN Ausgabe 26.03.08 – Exhibition »Ultimatum« Oliver Borner</li>
        <li>Sax – Top 5 exhibitions in march 2008</li>
        <li>Mopo 13.02.07 – Kunst von der Stange</li>
        <li>Skriptmanufaktura Magazin – Frühjahr 2007</li>
        <li>SZ 03.02.07 – Maler in der Manufaktur</li>
        <li>DNN 03.02.07 – Titel Kulturteil VW Manufaktur</li>
      </ul>
    </div>
     <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
